// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-deep: #050810;
  --bg-card: rgba(30, 41, 59, 0.7);
  --accent-primary: #3b82f6;
  --accent-secondary: #f59e0b;
  --text-main: #f8fafc;
  --text-dim: #94a3b8;
  --glass-border: rgba(255, 255, 255, 0.08);
}

.contact-wrapper {
  margin-top: 20px;
  background-color: #050810;
  /* Сложный градиент для создания глубины */
  background-image: 
    radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.15) 0%, transparent 35%),
    radial-gradient(circle at 100% 100%, rgba(245, 158, 11, 0.1) 0%, transparent 35%),
    radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 1) 0%, var(--bg-deep) 100%);  color: #f8fafc;
  padding-top: 80px;
  overflow: hidden;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  gap: 60px;
}

/* --- Текстовый блок --- */
.brand-title {
  font-size: 48px;
  font-weight: 800;
  background: linear-gradient(90deg, #42b693, #60e9bf);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 10px;
}

.sub-title {
  font-size: 32px;
  margin-bottom: 20px;
}

.description {
  font-size: 18px;
  line-height: 1.6;
  color: #94a3b8;
  max-width: 550px;
}

.highlight {
  color: #42b693;
  font-weight: 600;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(66, 182, 147, 0.1);
  border: 1px solid rgba(66, 182, 147, 0.3);
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 14px;
  margin-top: 24px;
  color: #60e9bf;
}

.dot {
  width: 8px;
  height: 8px;
  background: #42b693;
  border-radius: 50%;
  box-shadow: 0 0 10px #42b693;
  animation: pulse 2s infinite;
}

/* --- Изображение с эффектом свечения --- */
.image-block {
  position: relative;
  display: flex;
  justify-content: center;
}

.globe {
  width: 400px;
  filter: drop-shadow(0 0 30px rgba(66, 182, 147, 0.2));
  z-index: 2;
  animation: float 6s ease-in-out infinite;
}

.glow-effect {
  position: absolute;
  width: 300px;
  height: 300px;
  background: #42b693;
  filter: blur(120px);
  opacity: 0.15;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* --- Футер в стиле Glassmorphism --- */
.footer {
  margin-top: 100px;
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(10px);
  padding: 60px 24px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.footer-logo {
  font-size: 24px;
  font-weight: 700;
}

.footer-logo span {
  color: #42b693;
}

.footer-center {
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

.footer-links {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #42b693;
}

  .brand-title {
    font-size: 40px;
    color: red;
  }

/* --- Иконки соцсетей --- */
.footer-right {
  display: flex;
  gap: 15px;
}

.social-icon {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
}

.social-icon:hover {
  background: #42b693;
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(66, 182, 147, 0.2);
}

/* --- Анимации --- */
@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

/* --- Адаптивность --- */
@media (max-width: 1024px) {
  .container {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
  .description {
    margin: 0 auto;
  }
  .brand-title {
    font-size: 40px;
    color: var(--accent-secondary);
  }
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 40px;
  }
  .footer {
  margin-top: 0px;
}
  .globe {
    width: 280px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/ContactSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C;;;mFAGiF,GAAG,cAAc;EAClG,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,yCAAyC;EACzC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,iCAAiC;EACjC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;EAEE;IACE,eAAe;IACf,UAAU;EACZ;;AAEF,4BAA4B;AAC5B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,qBAAqB;AACrB;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,MAAM,qBAAqB,EAAE,YAAY,EAAE;EAC3C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,4BAA4B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;EACA,eAAe;AACjB;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[":root {\n  --bg-deep: #050810;\n  --bg-card: rgba(30, 41, 59, 0.7);\n  --accent-primary: #3b82f6;\n  --accent-secondary: #f59e0b;\n  --text-main: #f8fafc;\n  --text-dim: #94a3b8;\n  --glass-border: rgba(255, 255, 255, 0.08);\n}\n\n.contact-wrapper {\n  margin-top: 20px;\n  background-color: #050810;\n  /* Сложный градиент для создания глубины */\n  background-image: \n    radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.15) 0%, transparent 35%),\n    radial-gradient(circle at 100% 100%, rgba(245, 158, 11, 0.1) 0%, transparent 35%),\n    radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 1) 0%, var(--bg-deep) 100%);  color: #f8fafc;\n  padding-top: 80px;\n  overflow: hidden;\n  position: relative;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 24px;\n  gap: 60px;\n}\n\n/* --- Текстовый блок --- */\n.brand-title {\n  font-size: 48px;\n  font-weight: 800;\n  background: linear-gradient(90deg, #42b693, #60e9bf);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 10px;\n}\n\n.sub-title {\n  font-size: 32px;\n  margin-bottom: 20px;\n}\n\n.description {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #94a3b8;\n  max-width: 550px;\n}\n\n.highlight {\n  color: #42b693;\n  font-weight: 600;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(66, 182, 147, 0.1);\n  border: 1px solid rgba(66, 182, 147, 0.3);\n  padding: 8px 16px;\n  border-radius: 100px;\n  font-size: 14px;\n  margin-top: 24px;\n  color: #60e9bf;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background: #42b693;\n  border-radius: 50%;\n  box-shadow: 0 0 10px #42b693;\n  animation: pulse 2s infinite;\n}\n\n/* --- Изображение с эффектом свечения --- */\n.image-block {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.globe {\n  width: 400px;\n  filter: drop-shadow(0 0 30px rgba(66, 182, 147, 0.2));\n  z-index: 2;\n  animation: float 6s ease-in-out infinite;\n}\n\n.glow-effect {\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  background: #42b693;\n  filter: blur(120px);\n  opacity: 0.15;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* --- Футер в стиле Glassmorphism --- */\n.footer {\n  margin-top: 100px;\n  position: relative;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  background: rgba(15, 23, 42, 0.8);\n  backdrop-filter: blur(10px);\n  padding: 60px 24px;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.footer-logo {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.footer-logo span {\n  color: #42b693;\n}\n\n.footer-center {\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.footer-links {\n  margin-top: 10px;\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n}\n\n.footer-links a {\n  color: #94a3b8;\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\n.footer-links a:hover {\n  color: #42b693;\n}\n\n  .brand-title {\n    font-size: 40px;\n    color: red;\n  }\n\n/* --- Иконки соцсетей --- */\n.footer-right {\n  display: flex;\n  gap: 15px;\n}\n\n.social-icon {\n  width: 45px;\n  height: 45px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  text-decoration: none;\n  font-weight: bold;\n  transition: all 0.3s;\n}\n\n.social-icon:hover {\n  background: #42b693;\n  transform: translateY(-3px);\n  box-shadow: 0 10px 20px rgba(66, 182, 147, 0.2);\n}\n\n/* --- Анимации --- */\n@keyframes pulse {\n  0% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.2); opacity: 0.7; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-20px); }\n  100% { transform: translateY(0px); }\n}\n\n/* --- Адаптивность --- */\n@media (max-width: 1024px) {\n  .container {\n    flex-direction: column;\n    text-align: center;\n    gap: 40px;\n  }\n  .description {\n    margin: 0 auto;\n  }\n  .brand-title {\n    font-size: 40px;\n    color: var(--accent-secondary);\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n    gap: 40px;\n  }\n  .footer {\n  margin-top: 0px;\n}\n  .globe {\n    width: 280px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
